import { el, clear } from "../dom.js";

/**
 * The real data-retention policy is BLOCKED (open point in
 * Inner_Map_Especificacion_reconciliada_v2 §10). This screen only states
 * what is verifiably true of the alpha right now: everything stays in the
 * browser's sessionStorage, nothing is sent to a server, email capture is
 * off. It must be rewritten once the policy is approved — do not soften
 * this into a vaguer promise in the meantime.
 */
export function renderConsent(container: HTMLElement, onContinue: () => void): void {
  clear(container);
  const screen = el("section", { className: "screen" }, [
    el("span", { className: "eyebrow" }, ["Before you start"]),
    el("h1", {}, ["What happens to your answers."]),
    el("p", {}, [
      "Your answers are kept in this browser only (sessionStorage), so you can go back or reload without losing your progress. They are not sent to any server.",
    ]),
    el("p", {}, [
      "You are never asked for your email before seeing the full result. Saving it by email is switched off in this version while the data policy is being settled.",
    ]),
    el("p", {}, [
      "Closing this tab erases the session. There is no way to recover it afterwards.",
    ]),
    el(
      "button",
      { className: "btn", type: "button" },
      ["Understood, continue"],
    ),
  ]);
  const button = screen.querySelector("button")!;
  button.addEventListener("click", onContinue);
  container.append(screen);
}
